
<template>
  <div
    v-if="tabDatas"
    class="tabs"
  >
    <!-- tab 切换 -->
    <!-- <ul
      ref="tabNavParent"
      class="nav-bar clearfix"
    >
      <template v-for="(item) in tabDatas">
        <li
          v-show="item.show"
          :key="item.fieldkey"
          :class="{'active': item.fieldkey === selected}"
          @click="tabNavChange(item.fieldkey, $event)"
        >
          {{ item.fieldname }}
        </li>
      </template>
    </ul> -->
    <my-form
      :data="formData"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MyForm from './Form'

export default {
  components: {
    MyForm
  },
  props: {
    formData: {
      type: Object,
      default: () => { }
    }
    /* detailData: {
      type: Object,
      default: () => { }
    } */
  },
  data () {
    return {
      selected: this.$route.query.tab1 || 'demand_info'
    }
  },
  computed: {
    ...mapGetters('inquery/detailData', ['permissionInfo']),
    tabDatas () {
      if (!this.formData) return
      let { formData = {} } = this
      // delete formData.from_info
      delete formData.reception_info
      delete formData.audit_info
      delete formData.info
      let data = {}
      for (let k in formData) {
        if (!formData[k].child || !formData[k].child.length) {
          delete formData[k]
        }
        data[k] = {
          fieldkey: k,
          fieldname: formData[k].fieldname,
          component: MyForm,
          data: formData,
          show: true
        }
      }
      return data
    }
  },
  mounted () {
    // this.$nextTick(() => {
    this.setNavStyle()
    // })
  },
  methods: {
    // tabNavChange (k, ev) {
    //   this.selected = k

    //   this.setNavStyle()
    //   // let $navBar = document.querySelector('.container-left .nav-bar')
    //   // $navBar && ($navBar.style.borderBottom = 'none')
    //   /* if (this.$getScrollTop() > this.$refs.content.$el.offsetTop) {
    //     window.scrollTo(0, this.$refs.content && this.$refs.content.$el.offsetTop)
    //   } */
    // },
    setNavStyle () {
      // let $containerScroll = document.querySelector('.container-left .containerScroll')
      // let $navBar = document.querySelector('.container-left .nav-bar')

      // $containerScroll && $containerScroll.addEventListener('scroll', () => {
      //   const scrollTop = $containerScroll.scrollTop
      //   if ($navBar && $containerScroll && scrollTop > 0) {
      //     $navBar.style.borderBottom = 'solid 1px #ebebeb'
      //   } else {
      //     $navBar.style.borderBottom = 'none'
      //   }
      // }, false)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs::v-deep {
  position: relative;
  height: 100%;
  //padding-top: 48px;
  .containerScroll{
    padding-top: 0;
  }

  .nav-bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 48px;
    background-color: #fff;
    li {
      position: relative;
      float: left;
      margin-right: 24px;
      height: 47px;
      line-height: 47px;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      &.active {
        color: $primary-color;
        border-bottom: solid 2px $primary-color;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  ::v-deep .nav-wrap {
    overflow: initial;
  }
  ::v-deep .nav-bar {
    margin-right: -40px;
    // border-bottom: solid 1px #ebebeb;
    li {
      position: relative;
      top: 1px;
    }
  }
  .history-module.containerScroll, .from-module.containerScroll {
    //margin-right: -40px;
    padding: 24px 0;
    padding-right: 40px;
    height: 100%;
    overflow-y: scroll;
  }
}
</style>
